import Vue from 'vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAnchor,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleRight,
  faAngleDown,
  faArrowRight,
  faBarcode,
  faBan,
  faBell,
  faBook,
  faBriefcase,
  faBuilding,
  faCalendarAlt,
  faCaretDown,
  faCaretUp,
  faChartLine,
  faCheck,
  faCheckDouble,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCheckCircle,
  faClock,
  faCogs,
  faComments,
  faCopy,
  faDiagramProject,
  faDollarSign,
  faEllipsisH,
  faEnvelope,
  faEnvelopeOpen,
  faExclamationCircle,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFileAlt,
  faFileCsv,
  faFileExcel,
  faFileInvoiceDollar,
  faFilePdf,
  faFileUpload,
  faFileWord,
  faFileDownload,
  faFolderOpen,
  faGlobe,
  faGripVertical,
  faHome,
  faInbox,
  faInfoCircle,
  faLaptop,
  faLock,
  faLockOpen,
  faMapMarkerAlt,
  faMinus,
  faMinusSquare,
  faMinusCircle,
  faPaperPlane,
  faPencilAlt,
  faPercent,
  faPeopleArrows,
  faPhoneSquare,
  faPlus,
  faPlusSquare,
  faPlusCircle,
  faPrint,
  faQuestionCircle,
  faRobot,
  faSave,
  faSearch,
  faScrewdriverWrench,
  faSignInAlt,
  faSort,
  faSortDown,
  faSortUp,
  faSquareFull,
  faStar,
  faStopCircle,
  faTag,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faUpload,
  faUser,
  faUserEdit,
  faUserFriends,
  faUserPlus,
  faUserSecret,
  faUserTie,
  faUsers,
  faTruck,
  faUndo,
  faMobile,
  faUserMinus,
  faHistory,
  faUserSlash,
  faExclamationTriangle,
  faBars,
  faFileImage
} from '@fortawesome/free-solid-svg-icons';

// To use regular icons:
// npm install "@fortawesome/free-regular-svg-icons"
// import { faUser } from '@fortawesome/free-regular-svg-icons';
// <font-awesome-icon :icon="[ 'far', 'user' ]" />

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
  faAnchor,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleRight,
  faAngleDown,
  faArrowRight,
  faBarcode,
  faBan,
  faBars,
  faBell,
  faBook,
  faBriefcase,
  faBuilding,
  faCalendarAlt,
  faCaretDown,
  faCaretUp,
  faChartLine,
  faCheck,
  faCheckDouble,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCheckCircle,
  faClock,
  faCogs,
  faComments,
  faCopy,
  faDiagramProject,
  faDollarSign,
  faEllipsisH,
  faEnvelope,
  faEnvelopeOpen,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFileAlt,
  faFileCsv,
  faFileExcel,
  faFileImage,
  faFileInvoiceDollar,
  faFilePdf,
  faFileUpload,
  faFileWord,
  faFolderOpen,
  faFileDownload,
  faGlobe,
  faGripVertical,
  faHistory,
  faHome,
  faInbox,
  faInfoCircle,
  faLaptop,
  faLock,
  faLockOpen,
  faMapMarkerAlt,
  faMinus,
  faMinusSquare,
  faMinusCircle,
  faPaperPlane,
  faMobile,
  faPencilAlt,
  faPeopleArrows,
  faPercent,
  faPhoneSquare,
  faPlus,
  faPlusCircle,
  faPlusSquare,
  faPrint,
  faQuestionCircle,
  faRobot,
  faSave,
  faSearch,
  faScrewdriverWrench,
  faSignInAlt,
  faSort,
  faSortDown,
  faSortUp,
  faSquareFull,
  faStar,
  faStopCircle,
  faTag,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faUndo,
  faUpload,
  faUser,
  faUserEdit,
  faUserFriends,
  faUserPlus,
  faUserSecret,
  faUserSlash,
  faUserMinus,
  faUserTie,
  faUsers,
  faTruck
);

Vue.component('font-awesome-icon', FontAwesomeIcon);
